//@ts-nocheck
export default ($node: Element) => {
	setInterval(function(){
		var el=document.getElementById("fa_4");
		if(el){
			if (isNaN(parseInt(el.value)) == true){
				el.value = 0;
			}
			else{
				el.value = parseInt(el.value) + 17;
			}
		}
	}, 1000);

	function validateInputs (e){
		var makeValid = function(id){
			document.getElementById(id).className = "element mandatory";
		};
	};

	var makeInvalid = function(id, msg){
		document.getElementById(id).className = "element mandatory invalid";
	};

	window.addEventListener("load", function (e) {
		document.getElementById("optin_form").addEventListener("submit", validateInputs);
	});
}
